var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceProviding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "service_providing",
    transform: "translate(0 -1041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5883",
    "data-name": "Rectangle 5883",
    width: 64,
    height: 64,
    rx: 12,
    transform: "translate(0 1041)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_002-location",
    "data-name": "002-location",
    transform: "translate(19 1055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3664",
    "data-name": "Group 3664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3663",
    "data-name": "Group 3663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M61.5,0A13.516,13.516,0,0,0,48,13.5c0,6.97,11.084,20.447,12.349,21.962a1.5,1.5,0,0,0,2.3,0C63.916,33.947,75,20.47,75,13.5A13.516,13.516,0,0,0,61.5,0Zm0,32.121C57.767,27.42,51,17.973,51,13.5a10.5,10.5,0,1,1,21,0C72,17.973,65.234,27.42,61.5,32.121Z",
    transform: "translate(-48)",
    fill: "#0078d7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3666",
    "data-name": "Group 3666",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3665",
    "data-name": "Group 3665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M119.5,64a7.5,7.5,0,1,0,5.369,12.737,1.5,1.5,0,0,0-2.147-2.095A4.5,4.5,0,1,1,124,71.5a1.5,1.5,0,0,0,3,0A7.509,7.509,0,0,0,119.5,64Z",
    transform: "translate(-112 -64)",
    fill: "#0078d7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceProviding);
export default __webpack_public_path__ + "static/media/service_providing.48e78563cdfedfd2c1ff4948d5fe9948.svg";
export { ForwardRef as ReactComponent };